import { createFileRoute } from '@tanstack/react-router';
import Accordion from '../../components/accordion/accordion';
import { seo } from '../../utils/seo';

export const Route = createFileRoute('/_layout/faq')({
  head: () => ({ meta: seo({ title: 'Gyakori kérdések' }) }),
  component: FaqRoute
});

function FaqRoute() {
  return (
    <div className="container-fluid">
      <div className="page-content centered">
        <h1 className="page-title">Gyakori kérdések</h1>
        <div className="faq">
          <p className="faq-info">
            Mielőtt felveszed velünk a kapcsolatot, fusd át az alábbi gyakori
            kérdéseket.
            <br />
            Ha itt nem találod meg a választ a kérdésedre, keress minket bátran.
          </p>
          <div className="faq-section">
            <h2>Rendelés</h2>
            <Accordion title="Csak egy méret közül tudok választani a kiválasztott karkötőnél. Miért?">
              A kiválasztott karkötőből jelenleg csak az a méret elérhető
              készleten.
            </Accordion>
            <Accordion title="Miért nem érhető el nagyobb méret (L) az adott karkötőből?">
              Nagyobb méretű (L) karkötők jelenleg csak a férfias mintájú
              karkötőkből érhetők el.
            </Accordion>
            <Accordion title="Rossz méretet rendeltem. Mit tegyek?">
              Kérlek, vedd fel velünk a kapcsolatot, hogy egyeztetni tudjunk a
              cseréről.
            </Accordion>
            <Accordion title="Sérült, hibás karkötőt kaptam. Mit tegyek?">
              Mindent megteszünk a minőség fenttartása érdekében, de sajnos
              hibák mindig előfordulhatnak. Kérlek, vedd fel velünk a
              kapcsolatot, hogy megbeszélhessük a problémát. Kérheted a karkötő
              kijavítását, kicserélést vagy a karkötő árának és szállítási
              költségének visszatérítését. A hibás karkötő visszaküldéséről
              Neked kell gondoskodni, de a visszaküldés díját megtérítjük.
            </Accordion>
            <Accordion title="Milyen szállítási módok vannak?">
              <ul>
                <li>Postai levél</li>
                <li>FOXPOST csomagautomata</li>
                <li>Házhozszállítás futárral</li>
              </ul>
              <p>
                Ha csomagautomatába szeretnéd kérni a csomagod, a kosár oldalon
                tudsz csomagautomatát választani.
                <br />
                Ebben az esetben is ki kell tölteni a lakcímet a fizetés oldalon
                a számla kiállítás miatt, de a kiválasztott csomagautomatába
                küldjük a csomagod.
              </p>
              <p>
                Postai levél szállítási mód csak bankkártyás fizetés és átutalás
                esetén választható.
              </p>
            </Accordion>
            <Accordion title="Rossz szállítási címet adtam meg. Mit tegyek?">
              Kérlek, vedd fel velünk a kapcsolatot.
            </Accordion>
            <Accordion title="Nem érkezett meg a karkötő. Mit tegyek?">
              Kérlek olyan címet adj meg, ahova a posta vagy a futárszolgálat
              kézbesíteni tudja a csomagod.
              <br />
              Ha csomagautomatába szeretnéd kérni a csomagod, a kosár oldalon
              tudsz csomagautomatát választani. Ha a csomag nem érkezik meg,
              kérlek, vedd fel velünk a kapcsolatot, hogy orvosolni tudjuk a
              problémát.
            </Accordion>
            <Accordion title="Milyen fizetési módok vannak?">
              Bankkártyás fizetés, banki átutalás és utánvét közül lehet
              választani.
              <br />
              Banki átutalás esetén az átutalás közleményébe írd be a rendelés
              sorszámát, amit a rendelés elküldése után kapsz.
              <br />
              Rendelésed az összeg beérkezését követően küldjük.
            </Accordion>
          </div>
          <div className="faq-section">
            <h2>Karkötő</h2>
            <Accordion title="Érheti víz a karkötőmet?">
              Igen, a víz nem tesz kárt a karkötődben, de célszerű nem kitenni
              víznek huzamosabb ideig.
              <br />
              A vizes karkötőt ne vedd gyakran fel és le, mert eldeformálódhat
              az anyag.
              <br />
              Ha vizes lett a karkötő, hagyd a levegőn megszáradni.
              <br />
            </Accordion>
            <Accordion title="Hogyan tisztítsam a karkötőmet?">
              Tisztítsd hideg vagy langyos vízzel, puha szivacs vagy törlőrongy
              segítségével, majd hagyd a levegőn megszáradni.
              <br />
              Kerüld az erős, fehérítő, maró vegyszerek használatát (mint
              bármilyen más színes ruha esetében is).
            </Accordion>
            <Accordion title="Kérhetek személyre szóló mintát vagy szöveget a karkötőmre?">
              Egyelőre nem tervezünk személyre szóló minta vagy szöveg
              készítését.
            </Accordion>
          </div>
        </div>
      </div>
    </div>
  );
}
